import styled from 'styled-components';
import { NeutralBadge } from 'ui/badge';
import { caption, colors, spacing } from 'ui/theme';
import { Link } from 'ui/links';
import { ResourcePreview } from 'modules/missionControl/lib/components/ResourcePreview';

export const Item = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: ${spacing.threeQuarter};
  row-gap: ${spacing.eighth};
  padding: 0 ${spacing.half};
  grid-template-rows: auto auto;
  grid-template-areas:
    'thumbnail title'
    'thumbnail metadata';
`;

export const Thumbnail = styled.div`
  grid-area: thumbnail;
`;

export const StyledResourcePreview = styled(ResourcePreview)`
  grid-area: thumbnail;
`;

export const Title = styled.div`
  grid-area: title;
`;

export const StyledLink = styled(Link)`
  color: ${colors.textPrimary};
  text-decoration-color: transparent;
`;

export const StyledNeutralBadge = styled(NeutralBadge)`
  ${caption}
  color: ${colors.secondaryText};
  padding: ${spacing.single} ${spacing.quarter};
  text-transform: capitalize;
`;

export const Metadata = styled.div`
  grid-area: metadata;
  ${caption}
  color: ${colors.secondaryText};
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const RelativeTimeData = styled.span`
  white-space: nowrap;
`;
